package co.maytes.standupbot.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import co.maytes.standupbot.dashboard.components.feedback.ToastOverlay
import co.maytes.standupbot.dashboard.features.auth.AuthContainer
import co.maytes.standupbot.dashboard.features.ds.isDesignSystemRoute
import co.maytes.standupbot.dashboard.features.onboarding.LocalOnboardingStore
import co.maytes.standupbot.dashboard.features.onboarding.OnboardingStore
import co.maytes.standupbot.dashboard.features.theme.LocalThemeStore
import co.maytes.standupbot.dashboard.features.theme.SystemThemeListener
import co.maytes.standupbot.dashboard.features.theme.rememberThemeStore
import co.maytes.standupbot.dashboard.init.ensureJsJodaTimezoneLoaded
import co.maytes.standupbot.dashboard.init.initFrontendObservability
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.auth.TokenStore
import co.maytes.standupbot.dashboard.lib.config.AppConfig
import co.maytes.standupbot.dashboard.features.setup.SetupCheckStore
import co.maytes.standupbot.dashboard.features.setup.SetupStatusStore
import co.maytes.standupbot.dashboard.stores.LocalApiClient
import co.maytes.standupbot.dashboard.stores.LocalAuthStore
import co.maytes.standupbot.dashboard.stores.LocalSetupCheckStore
import co.maytes.standupbot.dashboard.stores.LocalSetupStatusStore
import co.maytes.standupbot.dashboard.stores.LocalUiStore
import co.maytes.standupbot.dashboard.stores.UiContainer
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    initFrontendObservability()
    ensureJsJodaTimezoneLoaded()
    val scope = rememberCoroutineScope()
    val api = remember { ApiClient(AppConfig.API_BASE_URL) }
    val tokenStore = remember { TokenStore(api.http, AppConfig.API_BASE_URL) }
    val authContainer = remember { AuthContainer(scope, api, tokenStore) }
    val uiContainer = remember { UiContainer(scope) }
    val setupStatusStore = remember { SetupStatusStore(api) }
    val setupCheckStore = remember { SetupCheckStore(api) }
    val onboardingStore = remember { OnboardingStore() }
    val themeStore = rememberThemeStore()
    SystemThemeListener(themeStore)

    LaunchedEffect(Unit) {
        api.wire(tokenStore)
        if (!isDesignSystemRoute()) authContainer.bootstrap()
    }

    SilkApp {
        CompositionLocalProvider(
            LocalApiClient provides api,
            LocalAuthStore provides authContainer,
            LocalUiStore provides uiContainer,
            LocalSetupStatusStore provides setupStatusStore,
            LocalSetupCheckStore provides setupCheckStore,
            LocalOnboardingStore provides onboardingStore,
            LocalThemeStore provides themeStore,
        ) {
            Box(modifier = Modifier.fillMaxSize()) {
                content()
                ToastOverlay()
            }
        }
    }
}
